import { byRegion } from 'app/shared-components/region';

// Canada books minor ailment appointments rather than clinics. Shared by both pitches below so
// they cannot drift apart.
const BOOKINGS = byRegion({
  uk: 'Service & clinic bookings',
  canada: 'Service & minor ailment bookings',
});

// Canada has no OTC shop, so it is not pitched there.
export const SALES_FEATURES = [
  'Your domain & branding',
  'Prescription ordering',
  BOOKINGS,
  ...byRegion({ uk: ['OTC e-commerce'], canada: [] }),
  'Standalone or embedded',
  'QR codes & marketing tools',
];

// The upgrade modal's "You're about to unlock" list. Canada has neither the OTC shop nor the
// private medicine clinic to unlock, so it promises neither.
export const UPGRADE_BENEFITS = [
  'Your branded website',
  'Prescription ordering',
  BOOKINGS,
  ...byRegion({ uk: ['Private medicine clinic', 'OTC e-commerce'], canada: [] }),
  'QR codes & marketing tools',
];
